import { createRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";
import { rootRoute } from "./rootRoute";

export const resetPasswordRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/reset-password",
    component: () => (
        <AuthLayout>
            <ResetPasswordForm />
        </AuthLayout>
    ),
});
